import {ClientContact, NetworkDescriptionAndDiagram, SystemInterconnection, SystemRolePrivilege} from '.';
import {CompanyType} from '../helpers';
import {NameAndIdentifier} from "./nameAndIdentifier";
import {SystemLocation} from "./systemLocation";
import {OtherDesignatedContact} from "./otherDesignatedContact";
import {SystemSecurityPlanApproval} from "./systemSecurityPlanApproval";
import {SensitivityCategorization} from "./sensitivityCategorization";
import {ControlOrigination} from "./controlOrigination";
import {LeveragedAuthorization} from "./leveragedAuthorization";
import {PortProtocolService} from "./portProtocolService";
import {StandartAndGuidance} from "./standartAndGuidance";
import {LawAndRegulation} from "./lawAndRegulation";
import {Device} from "./device";
import {InformationType} from "./informationType";
import {SeparationOfDuty} from "./separationOfDuty";
import {SeparationOfDutyRole} from "./separationOfDutyRole";
import {AuthorizedService} from "./authorizedService";
import {ExternalSystem} from "./externalSystem";
import {BoundaryTechnology} from "./boundaryTechnology";
import {SystemUser} from "./systemUser";
import {SeparatedUser} from "./separatedUser";

export class ClientITProfile {
  name?: string;
  ownerIds?: string;

  systemOwnerClientContact?: ClientContact;
  systemOwnerClientContactId?: number;

  securityPointClientContact?: ClientContact;
  securityPointClientContactId?: number;

  securityOfficerClientContact?: ClientContact;
  securityOfficerClientContactId?: number;

  systemName?: string;
  systemNameAbbreviation?: string;

  introduction?: string;
  generalPurpose?: string;
  typesOfInformation?: string;
  systemBoundaryPreDescription?: string;
  systemBoundaryDescription?: string;
  systemBoundaryDiagram?: string;//File;
  dataFlowDiagram?: string;//File;

  clientITProfileId?: number;

  systemEnvironmentDescription?: string;
  serverDiagram?: string;//File;

  serverDescriptions?: string;

  networkDescriptionsAndDiagrams?: NetworkDescriptionAndDiagram[];

  systemInterconnections?: SystemInterconnection[];
  systemRolePrivileges?: SystemRolePrivilege[];

  lastModifiedDate?: Date;
  profileType?: CompanyType;

  answers?: string;

  date?: string;
  description?: string;
  versionOfSsp?: string;
  sspCompanyName?: string;
  author?: string;
  includePolicies?: boolean;
  includeOwnerNames?: boolean;
  includeResponsibility?: boolean;

  primaryColor?: string;
  primaryTextColor?: string;
  secondaryColor?: string;
  secondaryTextColor?: string;
  tertiaryColor?: string;
  tertiaryTextColor?: string;

  recommendedControlIds?: number[];
  quiz?: string;
  quizData?: any;

  nameAndIdentifiers?: NameAndIdentifier[];
  systemLocations?: SystemLocation[];
  devices?: Device[];
  otherDesignatedContacts?: OtherDesignatedContact[];

  ownersSectionTitle?: string;
  ownersSectionVisible?: boolean;
  introSectionTitle?: string;
  introSectionVisible?: boolean;
  namesSectionTitle?: string;
  namesSectionVisible?: boolean;
  locationSectionTitle?: string;
  locationSectionVisible?: boolean;
  typesSectionTitle?: string;
  typesSectionVisible?:boolean;
  boundarySectionTitle?: string;
  boundarySectionVisible?:boolean;
  rolesSectionTitle?: string;
  rolesSectionVisible?:boolean;
  environmentSectionTitle?: string;
  environmentSectionVisible?:boolean;
  networkSectionTitle?: string;
  networkSectionVisible?:boolean;
  interconnectionSectionTitle?: string;
  interconnectionSectionVisible?:boolean;
  contactsSectionTitle?: string;
  contactsSectionVisible?:boolean;
  isFedRamp?: boolean;

  fedRampApplicationNumber?: string;

  sensitivityCategorizations?: SensitivityCategorization[];
  controlOriginations?: ControlOrigination[];
  leveragedAuthorizations?: LeveragedAuthorization[];
  portProtocolServices?: PortProtocolService[];
  standartAndGuidances?: StandartAndGuidance[];
  lawAndRegulations?: LawAndRegulation[];
  systemSecurityPlanApprovals?: SystemSecurityPlanApproval[];
  separationOfDuties?: SeparationOfDuty[];
  separationOfDutyRoles?: SeparationOfDutyRole[];
  authorizedServices?: AuthorizedService[];
  systemSensivityLevel?: number;
  confidentiality?: number;
  integrity?: number;
  availability?: number;
  abbreviationCategorization?: number;
  isSystemStatusOperational?: boolean;
  isSystemStatusUnderDevelopment?: boolean;
  isSystemStatusMajorModification?: boolean;
  isSystemStatusOther?: boolean;
  systemStatusOtherExplanation?: string;
  isSoftwareLayer?: boolean;
  isPlatformLayer?: boolean;
  isInfrastructureLayer?: boolean;
  isOtherLayer?: boolean;
  otherLayer?: string;
  isPublicCloud?: boolean;
  isPrivateCloud?: boolean;
  isGovernmentCloud?: boolean;
  isHybridCloud?: boolean;
  hybridCloud?: string;
  systemFunctionOrPurpose?: string;
  internalCount?: number;
  externalCount?: number;
  internalNextYearCount?: number;
  externalNextYearCount?: number;
  dataFlowDescription?: string;
  authorizingOfficial?: string;
  isFedRampAuthorizationPlanned?: boolean;
  systemEnvironmentAndInventory?: boolean;
  identityAssuranceLevel?: number;
  authenticatorAssuranceLevel?: number;
  federationAssuranceLevel?: number;
  isaSharesPii?: boolean;
  isaSharesPiiPublic?: boolean;
  piaPerformedForIsa?: boolean;
  isSorn?: boolean;
  sorn?: string;
  devicesSectionVisible?: boolean;
  rulesOfBehaviour?: string;
  contingencyPlan?: string;
  configurationManagementPlan?: string;
  incidentResponsePlan?: string;
  seperationOfDutiesMatrix?: string;
  csoName?: string;
  csoAbbreviation?: string;
  csoCategorization?: string;
  cspName?: string;
  cspAbbreviation?: string;
  fedRampPackageId?: string;
  serviceModel?: string;
  digitalIdentityLevel?: string;
  fipsLevel?: string;
  operationalDate?: string;
  deploymentModel?: string;
  authorizationPath?: string;
  informationTypes?: InformationType[];
  externalSystems?: ExternalSystem[];
  separationOfDutiesVisible?: string;
  digitalIdentityLevel1?: boolean;
  digitalIdentityLevel2?: boolean;
  digitalIdentityLevel3?: boolean;
  relatedAcronyms?: string;
  policiesAndProcedures?: string;
  isUserGuideUrl?: boolean;
  userGuide?: string;
  userGuideUrl?: string;
  controlImplementationSummary?: string;
  integratedInventoryWorkbook?: string;
  continuousMonitoringPlan?: string;
  supplyChainRiskManagementPlan?: string;
  cryptographicModulesTable?: string;
  includeSubitems?: boolean;

  deviceFieldNameDeviceName?: string;
  deviceFieldNameType?: string;
  deviceFieldNameManufacturer?: string;
  deviceFieldNameModel?: string;
  deviceFieldNameSerialNumber?: string;
  deviceFieldNameIP?: string;
  deviceFieldNameMAC?: string;
  deviceFieldNamePUID?: string;
  deviceFieldNameOwner?: string;
  deviceFieldNameLocation?: string;

  isDeviceNameVisible?: boolean;
  isTypeVisible?: boolean;
  isManufacturerVisible?: boolean;
  isModelVisible?: boolean;
  isSerialNumberVisible?: boolean;
  isIPVisible?: boolean;
  isMACVisible?: boolean;
  isPUIDVisible?: boolean;
  isOwnerVisible?: boolean;
  isLocationVisible?: boolean;

  deploymentType?: string;
  primaryOS?: string;
  identityManagement?: string;
  firewallProduct?: string;
  configManagementProduct?: string;
  devLanguage?: string;
  securityTools?: string;
  otherTech1?: string;
  otherTech2?: string;
  otherTech3?: string;
  diagram3d?: string;

  operatingSystemStatus?: number;
  databaseStatus?: number;
  fileStorageStatus?: number;
  containerScanningStatus?: number;
  architectureStatus?: number;
  devLanguageStatus?: number;
  configurationManagementStatus?: number;
  accessManagementStatus?: number;
  keyManagementStatus?: number;
  firewallStatus?: number;
  codeRepositoryStatus?: number;
  immutabilityStatus?: number;
  monitoringStatus?: number;
  codeScanningStatus?: number;
  applicationScanningStatus?: number;
  desktopSecurityStatus?: number;
  userAuthStatus?: number;
  loginSecurityStatus?: number;
  operatingSystemValue?: number;
  databaseValue?: number;
  fileStorageValue?: number;
  containerScanningValue?: number;
  architectureValue?: number;
  devLanguageValue?: number;
  configurationManagementValue?: number;
  accessManagementValue?: number;
  keyManagementValue?: number;
  firewallValue?: number;
  codeRepositoryValue?: number;
  immutabilityValue?: number;
  monitoringValue?: number;
  codeScanningValue?: number;
  applicationScanningValue?: number;
  desktopSecurityValue?: number;
  userAuthValue?: number;
  loginSecurityValue?: number;
  boundaryTechnologies?: BoundaryTechnology[];
  updateProjects?: boolean;
  updateProjectsIds?: number;
  systemUsers?: SystemUser[];
  separatedUsers?: SeparatedUser[];
  diagrams?: any[];
}
